import * as React from 'react';
import FormDropDown from '../FormDropDown/FormDropDown';
import FormField from '../FormField/FormField';
const FormFieldDropDown = ({ t, field, label, namespace, isOptional, dense, inline, ...props }) => (React.createElement(FormField, { t, field, label, namespace, isOptional, dense, inline },
    React.createElement(FormDropDown, { t, field, namespace: 'common', ...props, hideLabel: true })));
export default FormFieldDropDown;
